var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nodata"},[_c('p',[_vm._v("검색결과가 없습니다.")])])
}]

export { render, staticRenderFns }